import { Skeleton } from '@nike/eds'
import { type RootState, useAppSelector } from 'api/redux'
import { useTranslation } from 'react-i18next'
import { getGradeConfig, type GradeKey, type Unit } from 'types'
import { isBrimley, isFlight, isImpact } from 'utils/dcContext'
import './UnitDetailsPanel.scss'

interface UnitDetailsPanelProps {
  unit: Unit
  showImage: boolean
}

export const UnitDetailsPanel = ({ unit, showImage }: UnitDetailsPanelProps) => {
  const { t } = useTranslation()
  const gradeConfigs = useAppSelector((state: RootState) => state.application.gradeConfigs)
  const gradeConfig = getGradeConfig(unit.grade?.toUpperCase() as GradeKey, gradeConfigs)
  const isGraded = () => {
    return !!unit.grade
  }

  return (
    <div className={'flex-col flex-grow'}>
      <div className="grid grid-cols-[4fr,8fr] gap-y-1 text-3xl">
        <div className="font-bold text-5xl">{t('detail_panel.sku')}</div><div className={'text-5xl pb-2'}>{unit.productCode}-{unit.sizeCode}</div>
        <div className="font-bold">{t('detail_panel.description')}</div><div>{unit.styleDescription}</div>
        {!isImpact && !isFlight && !isBrimley && <><div className="font-bold">{t('detail_panel.coo')}</div><div>{t(`countries.${unit.countryOfOrigin}`)} ({unit.countryOfOrigin})</div></>}
        <div className="font-bold">{t('detail_panel.silhouette')}</div><div>{unit.silhouette}</div>
        <div className="font-bold">{t('detail_panel.upc')}</div><div>{unit.upc}</div>
        {isGraded() &&
          <>
            {/* If reason code is required, format as `{grade}   {reason}`, else as `Grade   {first char of grade}` */}
            <div className="font-bold">{gradeConfig?.needsReason ? gradeConfig?.display : t('detail_panel.grade')}</div>
            <div>{gradeConfig?.needsReason ? unit.gradeReason : gradeConfig?.display?.charAt(0)}</div>
          </>
        }
      </div>
      <div className={'image-container'}>
        {showImage && (!unit.imageUrl
          ? <div className="flex justify-center m-6">
            <Skeleton height={550} width={550} />
          </div>
          : <img id="materialImage" src={unit.imageUrl} alt="Material image" />
        )
        }
      </div>
    </div>
  )
}
